window.VegasComment = {
	updateCommentLikesInfo: function ($item, likes) {
		$like = $item.find('div.like');
		$like.removeClass('liked').removeClass('disliked');
		$like.find('.likes').attr('data-score', likes);

		$like.addClass('disliked');
		if (likes > 0) {
			$like.addClass('liked');
		} else if (likes < 0) {
			$like.addClass('disliked');
		}
	}
};

$(document).on('submit', '#form-add-review', function () {
	let $form = $(this);
	let route = $form.attr('action');
	let params = $form.serializeArray();
	let $modal = $form.closest('#modal-add-review');

	$form.find('.vg-error-alert').slideUp();
	
	let $button = $modal.find('button[type=submit]');
	$button.attr('disabled', true).text('Отправка...');

	$.post(route, params, function (data) {
		$button.attr('disabled', true).text('Добавить');
		
		if (!data.error) {
			let to = $modal.data('to');

			let $container = $('#'+to);
			$container.find('.noreviews').remove();
			$container.prepend(data.view);

			$modal.modal('hide');
		} else {
			if (data.type === 'rate') {
				$form.find('.vg-error-alert').slideDown();
			}
		}
	});

	return false;
});

$(document).on('click', '.vg-shop-reviews .item a.like', function () {
	$item = $(this).closest('.item');

	var params = {
		_token: App.csrf,
		id: $item.data('id')
	};

	$.post('/comments/like', params, function (data) {
		VegasComment.updateCommentLikesInfo($item, data.likes);
	});

	return false;
});
$(document).on('click', '.vg-shop-reviews .item a.dislike', function () {
	$item = $(this).closest('.item');

	var params = {
		_token: App.csrf,
		id: $item.data('id')
	};

	$.post('/comments/dislike', params, function (data) {
		VegasComment.updateCommentLikesInfo($item, data.likes);
	});

	return false;
});